import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';
import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderDisclaimer = (props: Props) => {
  const { disclaimer, rounded = true } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, rounded ? styles.roundedContainer : undefined];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <View style={styles.innerContainer}>
        <BodyText sizeMatch={['14']} style={match([undefined, styles.textSM])}>
          {disclaimer}
        </BodyText>
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.CREAM,
    overflow: 'hidden',
  },
  roundedContainer: {
    borderBottomStartRadius: theme.radius.medium,
    borderBottomEndRadius: theme.radius.medium,
  },
  textSM: {
    textAlign: 'center',
  },
  innerContainer: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
    padding: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  disclaimer: string;
  rounded?: boolean;
};
